import React from 'react';
import { Modal } from 'antd';

import { SaveOutlined } from '@ant-design/icons';
import { safeLocationHref } from '../helpers/pathValidator';

const successBind = {
  '201': {
    // redirect: '/service/quick/landing',
    // modal: false,
    // routeTo: '', 아직 지원 안됨
    title: '성공',
    content: '저장되었습니다.'
  }
};

const handler = (response) => {
  return new Promise((resolve, reject) => {
    if (successBind[response.status]) {
      const { redirect, routeTo, modal = true, title, content } = successBind[response.status];

      if (modal) {
        Modal.confirm({
          title,
          content,
          icon: <SaveOutlined />,
          okText: '확인',
          zIndex: 10001,
          cancelButtonProps: { style: { display: 'none' } },
          onOk: () => {
            resolve(true);
            route({ redirect, routeTo });
          }
        });
      } else {
        resolve(true);
        route({ redirect, routeTo });
      }
    } else {
      resolve(true);
    }
  });
};

const route = ({ redirect, routeTo }) => {
  if (redirect) {
    safeLocationHref(redirect);
  } else if (routeTo) {
  }
};
export default handler;
